import { render, staticRenderFns } from "./warehouses.vue?vue&type=template&id=2bb3dff8&scoped=true"
import script from "./warehouses.vue?vue&type=script&lang=js"
export * from "./warehouses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb3dff8",
  null
  
)

export default component.exports